<script setup lang="ts">


import { onMounted, ref } from 'vue'


const scriptSrc = 'https://sparxpres.dk/app/webintegration/static/module-loader.js'


interface Props {
	location: string
}


const props = defineProps<Props>()
const spxHtmlElement = ref<HTMLElement | null>(null)


function loadScript(licenceId: string) {
	if (document.querySelector(`script[src="${scriptSrc}"]`)) return
	const script = document.createElement('script')
	script.src = scriptSrc
	script.async = true
	script.onload = () => {
		(window as any).sparxpresClientLoader(licenceId)
	}
	document.head.appendChild(script)
}


onMounted(() => {
	const element = document.getElementById(`SPX_${props.location}`)
	if (!element || !spxHtmlElement.value) return


	const licenceId = element.dataset.licence ?? ''

	// Move element into our overlay wrapper immediately so the widget renders in place
	spxHtmlElement.value.appendChild(element)

	const style = document.createElement('style');
	style.innerHTML = `.sparxpres-xprespay-content,.sparxpres-logo{visibility: hidden!important;}`;
	document.body.appendChild(style);

	const applyOverlay = () => {
		const modalTrigger = element.querySelector('.sparxpres-modal-open') as HTMLElement | null
		if (!modalTrigger) return false

		const textElement = element.querySelector('.sparxpres-xprespay-text') as HTMLElement | null
		const sparXLogo = element.querySelector('.sparxpres-xprespay-logo')
		const xpresContent = element.querySelector('.sparxpres-xprespay-content') as HTMLElement | null



		if (sparXLogo !== null) sparXLogo.remove()
		if (textElement !== null) textElement.style.display = 'none'
		if (xpresContent !== null) xpresContent.style.visibility = 'hidden'

		// Expand the modal trigger button to fill the overlay container so
		// real user clicks reach the vendor handler directly — no JS forwarding.
		modalTrigger.style.position = 'absolute'
		modalTrigger.style.inset = '0'
		modalTrigger.style.width = '100%'
		modalTrigger.style.height = '100%'
		modalTrigger.style.opacity = '0'
		modalTrigger.style.cursor = 'pointer'
		modalTrigger.style.zIndex = '1'

		// Let the widget element fill the overlay wrapper
		element.style.position = 'relative'
		element.style.width = '100%'
		element.style.height = '100%'

		return true
	}

	// Try immediately in case the widget already rendered, otherwise observe
	if (!applyOverlay()) {
		const observer = new MutationObserver(() => {
			if (applyOverlay()) observer.disconnect()
		})
		observer.observe(element, { childList: true, subtree: true })
	}

	loadScript(licenceId)
})


</script>


<template>
	<!-- position:relative anchors the transparent modal-trigger overlay -->
	<div class="relative cursor-pointer">
		<!-- Visible custom content -->
		<slot>
			<div class="flex flex-col text-left text-xs">
				<span class="font-bold border-b">Delbetaling</span>
				<span>Læs mere</span>
			</div>
		</slot>
		<!--
			Widget holder overlaid over slot content.
			The .sparxpres-modal-open button inside is expanded to inset:0 at opacity 0,
			so real user clicks go straight to the vendor's modal handler.
		-->
		<div ref="spxHtmlElement" class="absolute inset-0 overflow-hidden" aria-hidden="true"></div>
	</div>
</template>
